module.exports = __webpack_public_path__ + "static/media/numberinfo.edc4abd7.svg";